/* eslint-disable @typescript-eslint/explicit-function-return-type, @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any -- This file is all about the unknown */
export function createSafeEnvironmentProxy<EnvironmentType>(sourceEnvironment: EnvironmentType, sourceName: string) {
  if (!('Proxy' in window)) {
    console.warn(
      `No Proxy in current execution environment, this function is a noop. Access to ${sourceName} isn't checked.`,
    )
    return sourceEnvironment
  }
  // eslint-disable-next-line @typescript-eslint/ban-types -- This is exactly what we want
  return new Proxy(sourceEnvironment as unknown as object, {
    get(env: any, propName: string) {
      const value = env[propName]
      const context = { propName, env, value, sourceEnvironment, sourceName }
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      if ([undefined, ''].includes(value)) {
        const message = `Undefined or empty string value for '${propName}' found in ${sourceName}!`
        console.warn(message, context)
        throw Error(message)
      }
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- This is exactly what we want
      return value
    },
  }) as EnvironmentType
}
